import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';

// Components
import Home from './Components/Home';
import Resume from './Components/Resume';
import Projects from './Components/Projects';
import Travel from './Components/Travel';
import Recipes from './Components/Recipes';
import Ninder from './Components/Data/Ninder';
import Valentine from './Components/Valentine';
import Date from './Components/Date';
import Date_Spanish from './Components/Date-Spanish';
import SelectDate from './Components/SubComponents/Select-Date';
import SelectDate_Spanish from './Components/SubComponents/Select-Date_Spanish';
import LocationSpoof from './Components/SubComponents/LocationSpoof';
import CafeAi from './Components/CafeAI';
import ElCarancho from './Components/ElCarancho';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/Resume" element={<Resume />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/Travel" element={<Travel />} />
      <Route path="/Recipes" element={<Recipes />} />
      <Route path="/ninder" element={<Ninder />} />
      <Route path="/Valentine" element={<Valentine />} />
      <Route path="/Date" element={<Date />} />
      <Route path="/Date-Spanish" element={<Date_Spanish />} />
      <Route path="/Select-Date" element={<SelectDate />} />
      <Route path="/Select-Date_Spanish" element={<SelectDate_Spanish />} />
      <Route path="/LocationSpoof" element={<LocationSpoof />} />
      <Route path="/CafeAi" element={<CafeAi />} />

      {/* NEW PAGE */}
      <Route path="/ElCarancho" element={<ElCarancho />} />

      <Route path="*" element={<div>404 Not Found</div>} />
    </Routes>
  );
}

export default App;
